import { EventRepository } from "../repository"

const EventController = {

    /**
    * @return {Object} requested eventlist
    */
    async getEvents() {
        const response: any = await EventRepository.getEvents();
        //console.log('MemberController.getMembers: ', response);
        const events = response?.data?.events || []
        events.forEach((m:any) => {
            //m.works = []
                //[WS 2023-12-16] quick'n'dirty workaround, due to objects and worked with array so far
            /*const works = []
            for (const key in m.works) works.push(m.works[key])
            m.works = WorkController.sortWorks(works)
            m.sumDayWorks = WorkController.getSumWorks(works, 0)
            m.sumHourWorks = WorkController.getSumWorks(works, 1) */
        })
        return events;
    },

    /**
    * @return {Object} requested eventlist
    */
    async getActiveEvent() {
        const response: any = await EventRepository.getActiveEvent();
        //console.log('EventController.getMembers: ', response.data.event);
        const event = response?.data?.event[0] || []
        return event;
    },    
}
export default EventController;